// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__-WYyp","slider":"Switch_slider__3jvWg","inputSwitch":"Switch_inputSwitch__O3TbW","round":"Switch_round__55Vkh"};